import Dashboard from './views/Dashboard.vue'

export const dashboardRoutes = [
  {
    path: '/home',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      auth: true,
      layout: 'home'
    }
  }
]
